/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oermwjefjidrRRHcrxyCjQ
// Component: 3_QVitiqMh

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import NewComponentItem from "../../components/widgets/NewComponentItem"; // plasmic-import: csXhXQDIqh/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_new_component.css"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/projectcss
import sty from "./PlasmicNewComponentSection.module.css"; // plasmic-import: 3_QVitiqMh/css

import eyeSvgZxKyHRa6Q6Pa from "../plasmic_kit_design_system/images/eyeSvg.svg"; // plasmic-import: Zx-kyHRa6Q6PA/picture

createPlasmicElementProxy;

export type PlasmicNewComponentSection__VariantMembers = {
  hideTitle: "hideTitle";
};
export type PlasmicNewComponentSection__VariantsArgs = {
  hideTitle?: SingleBooleanChoiceArg<"hideTitle">;
};
type VariantPropType = keyof PlasmicNewComponentSection__VariantsArgs;
export const PlasmicNewComponentSection__VariantProps =
  new Array<VariantPropType>("hideTitle");

export type PlasmicNewComponentSection__ArgsType = {
  title?: React.ReactNode;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNewComponentSection__ArgsType;
export const PlasmicNewComponentSection__ArgProps = new Array<ArgPropType>(
  "title",
  "children"
);

export type PlasmicNewComponentSection__OverridesType = {
  root?: Flex__<"div">;
  title?: Flex__<"div">;
  items?: Flex__<"div">;
};

export interface DefaultNewComponentSectionProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  hideTitle?: SingleBooleanChoiceArg<"hideTitle">;
  className?: string;
}

const $$ = {};

function PlasmicNewComponentSection__RenderFunc(props: {
  variants: PlasmicNewComponentSection__VariantsArgs;
  args: PlasmicNewComponentSection__ArgsType;
  overrides: PlasmicNewComponentSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hideTitle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hideTitle,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_oermwjefjidrRRHcrxyCjQ",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {(hasVariant($state, "hideTitle", "hideTitle") ? false : true) ? (
        <div
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames("all", sty.title, {
            [sty.titlehideTitle]: hasVariant($state, "hideTitle", "hideTitle"),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: "Section title",
            value: args.title,
            className: classNames(sty.slotTargetTitle, {
              [sty.slotTargetTitlehideTitle]: hasVariant(
                $state,
                "hideTitle",
                "hideTitle"
              ),
            }),
          })}
        </div>
      ) : null}
      <div
        data-plasmic-name={"items"}
        data-plasmic-override={overrides.items}
        className={classNames("all", sty.items)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <NewComponentItem
                className={classNames(
                  "__wab_instance",
                  sty.newComponentItem___50Oun
                )}
                controls={
                  <img
                    alt={""}
                    className={classNames(
                      "all",
                      "img",
                      "img__oermw",
                      sty.img___2Qggo
                    )}
                    loading={"lazy"}
                    src={eyeSvgZxKyHRa6Q6Pa}
                  />
                }
              />

              <NewComponentItem
                className={classNames(
                  "__wab_instance",
                  sty.newComponentItem__mplbv
                )}
                controls={
                  <img
                    alt={""}
                    className={classNames(
                      "all",
                      "img",
                      "img__oermw",
                      sty.img__ylGDf
                    )}
                    loading={"lazy"}
                    src={eyeSvgZxKyHRa6Q6Pa}
                  />
                }
              />
            </React.Fragment>
          ),
          value: args.children,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "title", "items"],
  title: ["title"],
  items: ["items"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  title: "div";
  items: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewComponentSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewComponentSection__VariantsArgs;
    args?: PlasmicNewComponentSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicNewComponentSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNewComponentSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewComponentSection__ArgProps,
          internalVariantPropNames: PlasmicNewComponentSection__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicNewComponentSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewComponentSection";
  } else {
    func.displayName = `PlasmicNewComponentSection.${nodeName}`;
  }
  return func;
}

export const PlasmicNewComponentSection = Object.assign(
  // Top-level PlasmicNewComponentSection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title: makeNodeComponent("title"),
    items: makeNodeComponent("items"),

    // Metadata about props expected for PlasmicNewComponentSection
    internalVariantProps: PlasmicNewComponentSection__VariantProps,
    internalArgProps: PlasmicNewComponentSection__ArgProps,
  }
);

export default PlasmicNewComponentSection;
/* prettier-ignore-end */
